/** Shared guard for keyboard handlers (issue #506): is the event aimed at
 *  a form control the user is typing into / operating?
 *
 *  When one of these is focused, the editor must NOT act on the key — a
 *  tool shortcut ("v", "x"), undo/redo, delete, or a snap modifier (Shift
 *  / Alt) firing while the user types into a name field or a calibration
 *  input is exactly the bug #506 is about. Every window-level keydown
 *  handler bails on this before doing anything.
 *
 *  Covers `<input>` (any type), `<textarea>`, `<select>` (its own type-
 *  ahead / arrow-key navigation owns the keystroke), and any
 *  contentEditable element. */
export function isTextTarget(t: EventTarget | null): boolean {
  if (!(t instanceof HTMLElement)) return false;
  const tag = t.tagName;
  return (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT" ||
    t.isContentEditable
  );
}
